import { createFileRoute } from '@tanstack/react-router';
import { UnitsScreen } from '@/features/units/UnitsScreen';

export const Route = createFileRoute('/_app/units')({
  component: UnitsScreen,
});
